/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { devices } from 'styles/devices';
import { colors } from 'styles/colors';

const SearchList = ({ results, className }) => (
   <List className={className}>
      {results?.map((result, index) => (
         <ListItem key={result?.id}>
            <StyledLink to={result?.path}>
               <Index>{index + 1}</Index>
               <InnerWrapper>
                  <Name>{result?.title}</Name>
                  {result?.category && <Category>{result?.category}</Category>}
               </InnerWrapper>
            </StyledLink>
         </ListItem>
      ))}
   </List>
);

SearchList.propTypes = {
   results: PropTypes.arrayOf(
      PropTypes.shape({
         ID: PropTypes.string,
         path: PropTypes.string,
         title: PropTypes.string,
         category: PropTypes.string
      })
   ).isRequired,
   className: PropTypes.string
};

SearchList.defaultProps = {
   className: ''
};

const StyledLink = styled(Link)`
   display: block;
   width: 100%;
   color: ${colors.neutral50};
   transition: all 0.25s ease-in-out;

   &:hover {
      color: ${colors.neutral30};
      text-decoration: none;
   }

   ${devices.tabletXL} {
      display: flex;
   }
`;

const List = styled.ul`
   list-style: none;
   padding: 0;
   margin: 20px 0 0;
   z-index: 900;

   ${devices.tabletXL} {
      margin: 40px 0 0;
   }
`;

const InnerWrapper = styled.div`
   ${devices.tabletXL} {
      display: flex;
      width: 100%;
   }
`;

const ListItem = styled.li`
   display: flex;
   width: 100%;
   padding: 10px 12px;
   border-bottom: 1px solid ${colors.neutral20};

   &:last-of-type {
      border-bottom: none;
   }

   ${devices.tabletXL} {
      padding: 20px 24px;
   }
`;

const Index = styled.span`
   display: block;
   margin-right: 20px;
   font-weight: 600;
`;

const Name = styled.span`
   display: block;
   font-weight: 600;

   ${devices.tabletXL} {
      width: 60%;
   }
`;

const Category = styled.span`
   display: block;
   margin-top: 5px;
`;

export default SearchList;
